import React from "react";

export const ConnectionsContext = React.createContext({
  connections: {},
  setConnections: () => {}
});
